import { array } from "yup";
import {
  LinkWithIcon,
  SkeletonLoader,
  SwitchAppInlineLoadingIcon,
} from "../../../components";

interface IGatewaySkeletonLoaderProps {
  message: string;
  count?: number;
}

export const GatewaySkeletonLoader = ({
  message,
  count = 5,
}: IGatewaySkeletonLoaderProps) => {
  return (
    <div>
      {/* <div className="flex-box flex-container justify-content--center align-items--center pt-5 pb-5">
        <SwitchAppInlineLoadingIcon description={message} />
      </div> */}

      {[1, 2, 3].map((count) => (
        <LinkWithIcon
          key={count}
          iconLeft={
            <SkeletonLoader
              type="placeholder"
              className="gateway-logo gateway-logo-skeleton"
            />
          }
          title={
            <SkeletonLoader type="text" className="gateway-title-skeleton" />
          }
          subtitle={
            <SkeletonLoader type="text" className="gateway-subtitle-skeleton" />
          }
          urlTarget="#"
          asButton
        />
      ))}
    </div>
  );
};
